import { useState, useEffect } from "react";

interface SwitchProps {
  isOn?: boolean; // Initial state
  onChange?: (isOn: boolean) => void; // Callback for state changes
  "aria-labelledby"?: string; // ID of element that labels this switch
  "aria-label"?: string; // Direct label for the switch
  "aria-describedby"?: string; // ID of element that describes this switch
}

function Switch({ isOn = false, onChange, "aria-labelledby": ariaLabelledby, "aria-label": ariaLabel, "aria-describedby": ariaDescribedby }: SwitchProps) {
  const [isChecked, setIsChecked] = useState(isOn);

  // Sync internal state when prop changes
  useEffect(() => {
    setIsChecked(isOn);
  }, [isOn]);

  const toggleSwitch = () => {
    setIsChecked(!isChecked);
    if (onChange) onChange(!isChecked);
  };

  // Handle key down to support space bar for toggle
  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === " " || e.key === "Enter") {
      e.preventDefault(); // Prevent scrolling when pressing spacebar
      toggleSwitch(); // Toggle the switch when space or enter is pressed
    }
  };

  return (
    <div className="relative">
      <span
        role="switch"
        aria-checked={isChecked}
        aria-labelledby={ariaLabelledby}
        aria-label={ariaLabelledby ? undefined : (ariaLabel || "Switch button")}
        aria-describedby={ariaDescribedby}
        tabIndex={0}
        onClick={toggleSwitch}
        onKeyDown={handleKeyDown}
        className={`rounded-full flex items-center cursor-pointer w-12 h-6 transition-all duration-200 relative z-0 focus-blue focus-visible:ring-2 focus-visible:ring-offset-2 ${
          isChecked ? "bg-bg-brand-primary-default" : "bg-bg-neutral-primary-default"
        }`}
      >
        {/* isChecked ? "bg-bg-brand-primary-default" : "bg-bg-neutral-primary-default" */}
        <span
          aria-hidden="true"
          className={`rounded-full w-5 h-5 transition-all duration-200 ${
            isChecked
              ? "translate-x-[26px] bg-white"
              : "translate-x-0.5 bg-white"
          }`}
        ></span>
      </span>
    </div>
  );
}

export default Switch;
